import { defineMessages } from 'react-intl';

export const locationResultCardContentMessages = defineMessages({
  orderChannel: {
    defaultMessage: `{channel, select,
      pickup {Pickup}
      delivery {Delivery}
      outpost {Outpost}
      other {}
    }`,
    description: 'Location Screen | Location Result Card | Order channel',
  },
  deliveryEstimate: {
    defaultMessage: '{estimate} minutes',
    description: 'Delivery | Estimate',
  },
  locationClosed: {
    defaultMessage: 'Closed',
    description: 'Location | Closed',
  },
});
